import { render, staticRenderFns } from "./EditModeSelector.vue?vue&type=template&id=0b6f6836&scoped=true"
import script from "./EditModeSelector.vue?vue&type=script&lang=js"
export * from "./EditModeSelector.vue?vue&type=script&lang=js"
import style0 from "./EditModeSelector.vue?vue&type=style&index=0&id=0b6f6836&scoped=true&lang=css"
import style1 from "./EditModeSelector.vue?vue&type=style&index=1&id=0b6f6836&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6f6836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b6f6836')) {
      api.createRecord('0b6f6836', component.options)
    } else {
      api.reload('0b6f6836', component.options)
    }
    module.hot.accept("./EditModeSelector.vue?vue&type=template&id=0b6f6836&scoped=true", function () {
      api.rerender('0b6f6836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditModeSelector.vue"
export default component.exports